import template from './compareButton.html';

let component = {
	template,
	transclude: true,
	bindings: {
		product:'='
	},
	controller: function (
		$scope,
		Compare
	) {
		"ngInject";

		var list = Compare.list;

		$scope.$on('COMPARE_LIST_CLEARED', function(e){
			list = [];
		})
		
		$scope.$on('COMPARE_LIST_CHANGED', function(e,l,action){
			list = l;
		});

		this.inList = (productId) => Compare.inList(productId);
		this.add = (product) => {
			Compare.add(product);
		};
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/compareButton/compareButton.component.js